import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import DiscountsAndBenefits from './DiscountsAndBenefits';

const DiscountsAndBenefitsBlock = ({data, context, programDiscounts, dealType, currentSubscriber, generalDetails}) => {
  return (
    <DiscountsAndBenefits
    data={data}
    context={context}
    programDiscounts={programDiscounts}
    dealType={dealType}
    currentSubscriber={currentSubscriber}
  />
  );
};

const mapStateToProps = (state) => {
  return {
    programDiscounts: state.cellcomTransactionSummary.transactionData.programDiscounts,
    dealType: state.cellcomTransactionSummary.transactionData.dealType,
    currentSubscriber: state.cellcomTransactionSummary.callular,
    generalDetails:
      state.cellcomTransactionSummary.transactionData.generalDetails,
  };
};

export default connect(mapStateToProps, null)(DiscountsAndBenefitsBlock);
